<template>
  <div class="container">
    <div
      :style="`transform: scale(${scale});`"
      :class="`image ${zoomClass}`"
      @click="zoomIn"
    ></div>
    <p v-if="zoomClass == 'super-high'" class="secret">
      Laissons tomber l'astronomie. La rue réputée la plus étroite et la maison la plus ancienne de Paris ont toutes les
      deux un autre domaine intrigant en commun. Pour le trouver, intéressez-vous à la légende de la première et au
      propriétaire de la seconde...
    </p>
    <div @click="$emit('close')" class="close">❌</div>
  </div>
</template>

<script>

export default {
  name: "OfficeSky",
  components: {},
  data() {
    return {
      zoomClass: "low",
      scale: 1,
      dragging: false,
      pos: { top: 0, left: 0, x: 0, y: 0 },
    };
  },
  methods: {
    zoomIn() {
      if (this.zoomClass == "low") {
        this.zoomClass = "normal";
        this.scale = 2;
        return;
      }
      if (this.zoomClass == "normal") {
        this.zoomClass = "high";
        this.scale = 4;
        return;
      }
      if (this.zoomClass == "high") {
        this.zoomClass = "super-high";
        this.scale = 6;
        return;
      }
      if (this.zoomClass == "super-high") {
        return;
      }
    },
  },
};
</script>

<style scoped>
.container {
  background-size: cover;
  overflow: scroll;
  position: relative;
}
image {
  height: auto;
  min-height: 70vh;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: fixed;
  top: 12%;
  right: 24%;
}
.close:hover {
  cursor: pointer;
}
.image.super-high:hover {
  cursor: grab;
}
.image.super-high:active {
  cursor: grabbing;
}
.image {
  background-image: url("../../assets/Escape/space-map.jpeg");
  background-repeat: no-repeat;
  background-size:cover;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
.image:hover {
  cursor: zoom-in;
}
.secret {
  position: absolute;
  font-size: 13px;
  top: 100%;
  left: 230%;
  color: rgb(70, 70, 70);
  font-family: sans-serif;
  width: 200px;
}
</style>
